<template>
  <div class="relative">
    <div :style="paddingBottom" />
    <img
      class="absolute left-0 top-0 w-full h-full object-cover"
      :src="pathToImage"
    />
  </div>
</template>

<script>
export default {
  name: "KImage",
  props: {
    aspectRatio: {
      type: Number,
      default: 1
    },
    src: {
      type: String,
      default: "https://images.unsplash.com/photo-1555985202-12975b0235dc"
    }
  },
  computed: {
    paddingBottom() {
      const percentage = (1 / this.aspectRatio) * 100;
      const paddingBottom = `${percentage}%`;

      return {
        "--padding-bottom": paddingBottom,
        "padding-bottom": "var(--padding-bottom)"
      };
    },
    pathToImage() {
      if (!this.src) {
        return require("@/assets/avatars/img_fallback.png");
      } else if (
        this.src.startsWith("https://") ||
        this.src.startsWith("http://")
      ) {
        return this.src;
      }

      return require(`@/assets/avatars/${this.src}`);
    }
  }
};
</script>

<style></style>
